import { render, staticRenderFns } from "./autism.vue?vue&type=template&id=46d9e3df&scoped=true"
import script from "./autism.vue?vue&type=script&lang=js"
export * from "./autism.vue?vue&type=script&lang=js"
import style0 from "./autism.vue?vue&type=style&index=0&id=46d9e3df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9e3df",
  null
  
)

export default component.exports